import { render, staticRenderFns } from "./week.vue?vue&type=template&id=49fb4417&scoped=true"
import script from "./week.vue?vue&type=script&lang=js"
export * from "./week.vue?vue&type=script&lang=js"
import style0 from "./week.vue?vue&type=style&index=0&id=49fb4417&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49fb4417",
  null
  
)

export default component.exports